import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(()=>({

  dialog:{
    width: '800px',
    boxSizing: 'border-box',
    overflow: 'hidden',
    height: '100%'
  },

  dialogPaper:{
    maxWidth: '800px !important',
    width: '800px',
    height: '90vh',
  },

  dialogHeader:{
    background: '#F6F6F7',
    height: 60,
    borderBottom: '1px solid #D5D2D5',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: '#29132E',
    fontSize: '18px',
    fontWeight: 500,
    paddingLeft: 24,
    paddingRight: 14,
    fontFamily: 'Roboto',
    boxSizing: 'border-box',
  },

  dialogContent:{
    padding: '32px 24px',
    overflow: 'hidden',
    width: '100%',
    boxSizing: 'border-box',
    height: 'calc(100% - 148px)',
  },

  selectAllWrapper:{
    marginBottom: 16,
    paddingLeft: 16,
  },

  tableWrapper:{
    height: 'calc(100% - 56px)',
    overflowY: 'auto',
  },

  dialogFooter:{
    height: 88,
    boxSizing: 'border-box',
    borderTop: '1px solid #D5D2D5',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '0 24px',
  },

  mainActionsWrapper:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 16,
  },

  mainButton:{
    backgroundColor: '#29132E',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#29132E',
    },
    '&:disabled': {
      backgroundColor: '#CFCACF',
      color: '#7F7692',
    },
  },

}));

export default useStyles;
